"use client";
import backImage from "../../../../src/Assets/image_14.png";
import greatImage from "../../../../src/Assets/PositiveExp.png";
import badimage from "../../../../src/Assets/negativeExp.png";
import { useLocation } from 'react-router-dom';
const Temp3 = ({
  logo,
  brand_logo,
  headingText = "Dear Guest,",
  subheadingText = "We request you to rate your experience with us",
  businessTypes2,
  businessImage2,
  ctaHeading = "Great Experience",
  ctaText = "Needs Improvement",
  styles = { backgroundColor: "#e8f8e8", textColor: "#333" },

  rightFileInputRef,
}) => {
   const location = useLocation();
    const handleClick = () => {
      if (location.pathname !== '/sucees_page') {
        rightFileInputRef.current.click();
      }
    };
  return (
    <div className="col-lg-4 HiddenClss step_8_show">
      <div className="preview-panel">
        <div
          className="mobile-frame mobile-frame2 custum_width_mobile"
          style={{
            backgroundImage: ``,
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%",
            // backgroundColor: "#f5f5f5",
            // minHeight: "100vh",
            position: "relative",
            fontFamily:
              "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
          }}
        >
          <div
            className="mobile-content"
            style={{ backgroundColor: "transparent" }}
          >
            {/* Logo Preview */}
            <div
              className="logo-preview"
                 onClick={handleClick}
              style={{
                marginTop: "60px",
                border: "1px solid #777",
                padding: "20px 40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                type="file"
                ref={rightFileInputRef}
                accept="image/*"
                style={{ display: "none" }}
              />
              {logo ? (
                <img
                  src={logo || brand_logo}
                  alt="Brand Logo"
                  className="preview-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = brand_logo;
                  }}
                  style={{ maxWidth: "80px", maxHeight: "70px" }}
                />
              ) : (
                <div
                  className="logo-placeholder"
                  style={{
                    color: "#777",
                    fontSize: "24px",
                    fontWeight: 500,
                    letterSpacing: "1px",
                  }}
                >
                  PLACE LOGO
                </div>
              )}
            </div>

            {/* Heading & Subheading */}
            <div
              className="preview-heading"
              style={{
                marginTop: "30px",
                textAlign: "center",
                fontSize: "18px",
                fontWeight: 600,
              }}
            >
              {headingText}
            </div>
            <div
              className="preview-subheading"
              style={{
                fontSize: "13px",
                color: "#555",
                maxWidth: "250px",
                textAlign: "center",
                margin: "10px auto",
              }}
            >
              {subheadingText}
            </div>

            {/* Rating Buttons (replacing Social Icons) */}
            <div
              className="social-icons"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                marginTop: "60px",
                width: "100%",
                maxWidth: "300px",
                margin: "60px auto 0",
              }}
            >
              <button
                className="rating-button positive"
                style={{
                  width:"100%",
                  display: "flex",
                  alignItems: "center",
                  padding: "12px 20px",
                  borderRadius: "30px",
                  border: "none",
                  fontSize: "16px",
                  fontWeight: 500,
                  cursor: "pointer",
                  backgroundColor: "rgb(240 255 240)",
                  color: "#333",
                }}
              >
                <img
                  src={greatImage}
                  alt="Great Experience"
                  style={{ width: "24px", height: "24px", marginRight: "15px" }}
                />
                <span>{ctaHeading}</span>
              </button>

              <button
                className="rating-button negative"
                style={{
                    width:"100%",
                  display: "flex",
                  alignItems: "center",
                  padding: "12px 20px",
                  borderRadius: "30px",
                  border: "none",
                  fontSize: "16px",
                  fontWeight: 500,
                  cursor: "pointer",
                  backgroundColor: "rgb(255 240 240)",
                  color: "#333",
                }}
              >
                <img
                  src={badimage}
                  alt="Needs Improvement"
                  style={{ width: "24px", height: "24px", marginRight: "15px" }}
                />
                <span>{ctaText}</span>
              </button>
            </div>

            <div className="preview-footer" style={{ display: "none" }}>
              Powered by Your <span>Wowreviews</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Temp3;
